import { IconType } from "@edaz/edazkit/Icon";
import { preventDefault, registerView, View, ViewComponent } from "@frui.ts/views/dist";
import { Observer, observer } from "mobx-react-lite";
import * as React from "react";
import { Jumbotron } from "react-bootstrap";
import ChargeManagementContactViewModel from "viewModels/chargeManagement/chargeManagementEdit/chargeManagementContactViewModel";
import ChargeManagementActiveChargeLicensePlateChangeViewModel from "viewModels/chargeManagement/chargeManagementEdit/chargeManagementActiveChargeLicensePlateChangeViewModel";
import ChargeManagementEditViewModel from "viewModels/chargeManagement/chargeManagementEdit/chargeManagementEditViewModel";
import ChargeManagementReceiptViewModel from "viewModels/chargeManagement/chargeManagementEdit/chargeManagementReceiptViewModel";
import ChargeManagementValidityViewModel from "viewModels/chargeManagement/chargeManagementEdit/chargeManagementValidityViewModel";
import LoadingModal from "../../common/loadingModal/loadingModal";
import ExtendedLoadingModal from "../../common/loadingModal/extendedLoadingModal";
import ChargeEditForm from "./chargeEditForm";
import ChargeInfo from "./chargeInfo";
import ChargeManagementHeader from "./chargeManagementHeader";
import ChargeRefund from "./chargeRefund";
import Portal from "../../eshop/order/components/portal";
import { turnstileSiteKey } from "../../../config";
import ChargeManagementLicensePlateChangeViewModel from "viewModels/chargeManagement/chargeManagementEdit/chargeManagementLicensePlateChangeViewModel";
import ChargeManagementBeforeValidChargeLicensePlateChangeViewModel from "viewModels/chargeManagement/chargeManagementEdit/chargeManagementBeforeValidChargeLicensePlateChangeViewModel";

function getIconType(child: any) {
  let icon: IconType;
  if (child instanceof ChargeManagementReceiptViewModel) {
    icon = IconType.Mail;
  } else if (child instanceof ChargeManagementContactViewModel) {
    icon = IconType.Bell;
  } else if (child instanceof ChargeManagementValidityViewModel) {
    icon = IconType.CalendarWithArrow;
  } else {
    icon = IconType.Car;
  }

  return icon;
}

function getRejectedReason(child: any, vm: ChargeManagementEditViewModel) {
  let reason: any;
  if (child instanceof ChargeManagementReceiptViewModel) {
    reason = vm.rejectionReasonObtainingPaymentConfirmation;
  } else if (child instanceof ChargeManagementContactViewModel) {
    reason = vm.rejectionReasonContact;
  } else if (child instanceof ChargeManagementValidityViewModel) {
    reason = vm.rejectionReasonValidityChange;
  } else if (child instanceof ChargeManagementActiveChargeLicensePlateChangeViewModel) {
    reason = vm.rejectionReasonVehicleChangeDuringValidity;
  } else if (child instanceof ChargeManagementBeforeValidChargeLicensePlateChangeViewModel) {
    reason = vm.rejectionReasonVehicleChangeBeforeValidity;
  }

  return reason;
}

const ChargeManagementEditView: ViewComponent<ChargeManagementEditViewModel> = observer(({ vm }) => (
  <Jumbotron className="p-3 p-lg-4 p-xl-7 col-12">
    <div className="p-3 p-lg-4 p-xl-7">
      <ChargeManagementHeader vm={vm} />
      {vm.isRefunded && vm.charge?.refund && <ChargeRefund vm={vm} />}
      <div>
        <ChargeInfo vm={vm} />
        {!vm.isRefunded &&
          vm.sectionsChildren.map((child, index) => (
            <div key={index}>
              <ChargeEditForm
                key={child.navigationName}
                onSubmit={(e, token) => {
                  e.preventDefault();
                  if (
                    child instanceof ChargeManagementValidityViewModel ||
                    child instanceof ChargeManagementActiveChargeLicensePlateChangeViewModel ||
                    child instanceof ChargeManagementBeforeValidChargeLicensePlateChangeViewModel
                  ) {
                    child.submit(token);
                  } else {
                    child.submit();
                  }
                }}
                onValidate={child.validate}
                onCancelSecondStep={
                  child instanceof ChargeManagementValidityViewModel ||
                  child instanceof ChargeManagementLicensePlateChangeViewModel
                    ? child.onCancelSecondStep
                    : undefined
                }
                toggle={child.toggle}
                collapsed={child.collapsed}
                notAllowedBySourceType={
                  child instanceof ChargeManagementReceiptViewModel || child instanceof ChargeManagementContactViewModel
                    ? false
                    : vm.notAllowedByOrderSourceType
                }
                afterValidityStart={
                  child instanceof ChargeManagementReceiptViewModel || child instanceof ChargeManagementContactViewModel
                    ? false
                    : vm.afterValidityStart
                }
                rejectedReason={getRejectedReason(child, vm)}
                chargeType={vm.getChargeType}
                icon={getIconType(child)}
                className={index === vm.children.length - 1 ? "border-top border-bottom" : "border-top"}
                warning={child instanceof ChargeManagementReceiptViewModel ? false : undefined}
                info={child instanceof ChargeManagementReceiptViewModel ? false : undefined}
                toolbox={child instanceof ChargeManagementReceiptViewModel ? false : undefined}
                customSuccessMessage={
                  child instanceof ChargeManagementReceiptViewModel && child.charge?.emailAddress
                    ? child.customSuccessMessage
                    : undefined
                }
                customInfoMessage={child instanceof ChargeManagementContactViewModel ? child.customInfoMessage : undefined}
                vm={child}
                vmParent={vm}
                success={child.success}
                errorMessage={child.errorMessage}
                canEdit={child.canEdit}
                secondStepErrorMessage={child.secondStepErrorMessage}
                secondStepLoading={child.secondStepLoading}
                showSecondStep={child.showSecondStep}
                hideConfirmChangeButton={child.hideConfirmChangeButton}
                warningMessages={child.warningMessages}
                localize={(code: string) => child.translate(`${child.navigationName}.${code}`)}>
                <Observer>{() => <View vm={child} />}</Observer>
                <ExtendedLoadingModal translate={vm.translate} isLoading={child.isLoading} isBusy={child.busyWatcher.isBusy} />
              </ChargeEditForm>
            </div>
          ))}
      </div>
      {vm.codeChangedAlertViewModel && <Observer>{() => <View vm={vm.codeChangedAlertViewModel} />}</Observer>}
    </div>
  </Jumbotron>
));

registerView(ChargeManagementEditView, ChargeManagementEditViewModel);
